<template>
  <div class="animated fadeIn">
    <SidebarLogsUsuarios
      @apply-filters="onApplyFilters"
      @clear-filters="onClearFilters"
    />

    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user-shield"></i> Auditoria - Log de Usuários</h3>
      </div>
    </div>

    <Tables
      ref="tableGrid"
      :columns="[
        'USUÁRIO',
        'LOGIN DO USUÁRIO',
        'AÇÃO',
        'DATA E HORA',
        'RESPONSÁVEL PELA AÇÃO'
      ]"
      :showNew="false"
      :showReload="true"
      :showSearch="true"
      :showTipFooter="false"
      :showPaging="true"
      v-on:Search="onShowSearch"
      v-on:Load="onLoadFromTable"
      v-on:Reload="onReloadFromTable"
    >
      <template slot="table-header-buttons">
        <a
          href="javascript:void(0);"
          v-b-tooltip.hover
          :title="'Exportar XLS'"
          @click="exportToExcel"
        >
          <i class="fas fa-file-excel text-third" style="font-size: 15px"></i>
        </a>
      </template>
      <tr
        v-for="log in logs"
        :key="log.id"
        :class="{ 'loading-opacity': isLoading }"
      >
        <TableColumn :IsText="true" :value="getUserName(log)" :status="1" />
        <TableColumn :IsText="true" :value="getUserLogin(log)" :status="1" />
        <TableColumn
          :IsText="true"
          :value="getActionLabel(log.action)"
          :class="getActionClass(log.action)"
          :status="1"
        />
        <TableColumn
          :IsText="true"
          :value="formatDateTime(log.date)"
          :status="1"
        />
        <TableColumn
          :IsText="true"
          :value="getAuthorName(log.authorId)"
          :status="1"
        />
      </tr>
    </Tables>
  </div>
</template>

<script>
import Tables from '@/components/forms/Tables.vue'
import TableColumn from '@/components/forms/TableColumn.vue'
import SidebarLogsUsuarios from '../search/SidebarLogsUsuarios.vue'
import AuditRepository from '@/shared/http/repositories/auditoria/audit'
import { toast, loading } from '@/shared/utils/UIHelper'
import { FileDownloadHelper } from '@/shared/utils/FileDownloadHelper'

export default {
  name: 'LogsUsuariosList',
  components: {
    Tables,
    TableColumn,
    SidebarLogsUsuarios
  },
  data () {
    return {
      logs: [],
      pagination: {
        page: 0,
        size: 20,
        totalElements: 0,
        totalPages: 0
      },
      isLoading: false,
      isExporting: false,
      authorsCache: this.loadAuthorsCache(),
      filters: {
        area: 'USUARIOS'
      }
    }
  },
  methods: {
    onLoadFromTable () {
      const page = this.$refs.tableGrid.pagingIndex || 0
      const size = this.$refs.tableGrid.pagingLimit || 20
      this.onLoad(page, size)
    },

    onReloadFromTable () {
      const size = this.$refs.tableGrid.pagingLimit || 20
      this.onLoad(0, size)
    },

    async onLoad (page = 0, size = 20) {
      this.isLoading = true

      try {
        const response = await AuditRepository.findAll(
          { ...this.filters, sort: 'operationDate,desc' },
          page,
          size
        )

        if (response && response.data) {
          let normalizedResponse = { ...response }

          if (response.data._embedded) {
            const embeddedKey = Object.keys(response.data._embedded)[0]
            const content = response.data._embedded[embeddedKey] || []
            const pageInfo = response.data.page || {}

            normalizedResponse = {
              status: 200,
              data: {
                content: content,
                number: pageInfo.number || 0,
                size: pageInfo.size || size,
                totalElements: pageInfo.totalElements || 0,
                totalPages: pageInfo.totalPages || 0
              }
            }
          } else if (response.data.content) {
            normalizedResponse = {
              status: 200,
              data: {
                content: response.data.content,
                number: response.data.number || 0,
                size: response.data.size || size,
                totalElements: response.data.totalElements || 0,
                totalPages: response.data.totalPages || 0
              }
            }
          } else {
            normalizedResponse = {
              status: 200,
              data: {
                content: [],
                number: 0,
                size: size,
                totalElements: 0,
                totalPages: 0
              }
            }
          }

          this.logs = normalizedResponse.data.content || []

          this.pagination = {
            page: normalizedResponse.data.number,
            size: normalizedResponse.data.size,
            totalElements: normalizedResponse.data.totalElements,
            totalPages: normalizedResponse.data.totalPages
          }

          if (this.$refs.tableGrid) {
            this.$refs.tableGrid.loading = false
            this.$refs.tableGrid.LoadAllByData(normalizedResponse)
          }

          if (normalizedResponse.data.totalElements === 0) {
            toast.info(
              'Nenhum resultado encontrado para os filtros aplicados'
            )
          }

          await this.loadAuthorsInfo()
        } else {
        }
      } catch (error) {
        this.logs = []
        this.pagination = {
          page: 0,
          size: 20,
          totalElements: 0,
          totalPages: 0
        }

        if (this.$refs.tableGrid) {
          this.$refs.tableGrid.loading = false
          this.$refs.tableGrid.LoadAllByData({
            status: 200,
            data: {
              content: [],
              number: 0,
              size: size,
              totalElements: 0,
              totalPages: 0
            }
          })
        }

        const errorStatus =
            (error && error.status) ||
            (error && error.response && error.response.status)

        if (errorStatus === 404) {
          toast.info('Nenhum resultado encontrado para os filtros aplicados')
        } else if (!error) {
          toast.error('Erro desconhecido ao carregar logs')
        } else if (errorStatus === 403) {
          toast.error('Você não tem permissão para acessar os logs')
        } else if (errorStatus === 500) {
          toast.error('Erro interno do servidor')
        } else if (!errorStatus) {
          toast.error(
            'Não foi possível conectar ao servidor. Verifique se a API está rodando.'
          )
        } else {
          toast.error(
            'Erro ao carregar logs de auditoria (Status: ' + errorStatus + ')'
          )
        }
      } finally {
        this.isLoading = false
      }
    },

    loadAuthorsCache () {
      try {
        const cached = localStorage.getItem('audit_authors_cache')
        return cached ? JSON.parse(cached) : {}
      } catch (error) {
        return {}
      }
    },

    saveAuthorsCache () {
      try {
        localStorage.setItem(
          'audit_authors_cache',
          JSON.stringify(this.authorsCache)
        )
      } catch (error) {
        // Silently fail
      }
    },

    async loadAuthorsInfo () {
      if (!this.logs || this.logs.length === 0) {
        return
      }

      const authorIds = [...new Set(this.logs.map(log => log.authorId))]
      let cacheUpdated = false

      for (const authorId of authorIds) {
        if (!this.authorsCache[authorId]) {
          const authorInfo = await AuditRepository.getAuthorInfo(authorId)
          if (authorInfo && authorInfo.pessoa) {
            this.authorsCache[authorId] =
                authorInfo.pessoa.nome || authorInfo.username || 'N/D'
            cacheUpdated = true
          } else if (authorInfo && authorInfo.username) {
            this.authorsCache[authorId] = authorInfo.username
            cacheUpdated = true
          } else {
            this.authorsCache[authorId] = 'N/D'
            cacheUpdated = true
          }
        }
      }

      if (cacheUpdated) {
        this.saveAuthorsCache()
      }
    },

    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },

    onApplyFilters (filters) {
      this.filters = { ...filters }
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
      if (this.$refs.tableGrid) {
        this.$refs.tableGrid.pagingIndex = 0
        this.$refs.tableGrid.currentPage = 1
      }
      this.onLoadFromTable()
    },

    onClearFilters () {
      this.filters = { area: 'USUARIOS' }
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
      if (this.$refs.tableGrid) {
        this.$refs.tableGrid.pagingIndex = 0
        this.$refs.tableGrid.currentPage = 1
      }
      this.onLoadFromTable()
    },

    getUserName (log) {
      if (!log.description) return 'N/D'
      return log.description || 'N/D'
    },

    getUserLogin (log) {
      if (!log.description) return 'N/D'
      return log.description || 'N/D'
    },

    getActionLabel (action) {
      const actions = {
        CRIAR: 'Criação',
        EDITAR: 'Alteração',
        BLOQUEAR: 'Bloqueio',
        INATIVAR: 'Inativação',
        EXCLUIR: 'Exclusão',
        DESBLOQUEAR: 'Desbloqueio',
        ATIVAR: 'Ativação'
      }
      return actions[action] || action
    },

    getActionClass (action) {
      const classes = {
        CRIAR: 'text-success font-weight-bold',
        EDITAR: 'text-primary',
        BLOQUEAR: 'text-danger font-weight-bold',
        INATIVAR: 'text-warning font-weight-bold',
        EXCLUIR: 'text-danger font-weight-bold',
        DESBLOQUEAR: 'text-success',
        ATIVAR: 'text-success'
      }
      return classes[action] || ''
    },

    formatDateTime (date) {
      if (!date) return ''
      const d = new Date(date)
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    },

    getAuthorName (authorId) {
      return this.authorsCache[authorId] || 'Carregando...'
    },

    async exportToExcel () {
      if (this.pagination.totalElements === 0) {
        toast.warning('Não há dados para exportar')
        return
      }

      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Deseja exportar ${this.pagination.totalElements} registro(s) para Excel?`,
        {
          title: 'Confirmar Exportação',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Sim, exportar',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (!confirmed) return

      this.isExporting = true
      loading.push()

      try {
        const response = await AuditRepository.exportToExcel(this.filters)

        const filename = FileDownloadHelper.generateTimestampFilename(
          'auditoria_logs_usuarios',
          'xlsx'
        )
        FileDownloadHelper.downloadFile(response.data, filename)

        toast.success('Arquivo exportado com sucesso!')
      } catch (error) {
        console.error('Erro ao exportar:', error)

        if (error && error.response && error.response.status === 404) {
          toast.error('Nenhum registro encontrado para exportação')
        } else if (error && error.response && error.response.status === 500) {
          toast.error('Erro no servidor ao gerar arquivo')
        } else {
          toast.error('Erro ao exportar arquivo Excel')
        }
      } finally {
        this.isExporting = false
        loading.pop()
      }
    }
  },
  mounted () {
    // Carregamento inicial
    this.$nextTick(() => {
      this.onLoadFromTable()
    })
  }
}
</script>

<style scoped>
  .loading-opacity {
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/auditoria/logs-usuarios/components/list/LogsUsuariosList.vue